import React from 'react';
import LockIcon from '@mui/icons-material/LockOutlined';
import { CLIP, VIDEO_TYPE } from '../../enums';
import styles from './Favourites.module.scss';

export const AngleLock = ({ clip, videos, inline = false, clipWidth }: {
  clip: CLIP;
  videos?: VIDEO_TYPE[];
  inline?: boolean;
  clipWidth?: number;
}) => {
  if (clip.locked_angle_id == null) return null;
  const angleIndex = (clip.videos?.length ? clip.videos : videos)?.findIndex((item) => String(item.id) === String(clip.locked_angle_id)) ?? -1;
  const label = angleIndex >= 0 ? `Locked angle ${angleIndex + 1}` : 'Locked angle';
  const compactSize = clipWidth !== undefined && clipWidth < 30 ? Math.max(0, Math.min(8, (clipWidth - 3) / 2)) : undefined;
  return <span className={inline ? styles.angleLockInline : styles.angleLock}
    style={!inline && compactSize !== undefined ? {
      width: compactSize, height: compactSize,
      '--angle-lock-inset': '1px', '--angle-lock-offset': `${compactSize + 2}px`,
    } as React.CSSProperties : undefined}
    title={label} role="img" aria-label={label}><LockIcon /></span>;
};
